module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.kitoltes_valaszto != false) ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "competition-items"
  }, _vm._l((_vm.fills), function(fill, i) {
    return _c('div', {
      staticClass: "competition-item-outer"
    }, [_c('div', {
      staticClass: "competition-item"
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-file-o"
    }), _vm._v("\n              " + _vm._s(fill.osztondij) + "\n            "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.datumFormazas(fill.datetime)) + " ("), _c('strong', [_vm._v(_vm._s(fill.status))]), _vm._v(")")]), _vm._v(" "), _c('button', {
      staticClass: "button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.kitoltesLekerdezes(_vm.$route.query.id, fill.id)
        }
      }
    }, [_vm._v("Tovább")])])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.kitoltesLekerdezes(_vm.$route.query.id, 0)
      }
    }
  }, [_vm._v("Új kitöltés")])]) : _vm._e(), _vm._v(" "), (_vm.fill_info == '' && _vm.kitoltes_valaszto == false) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n          Pályázat választás\n        ")]), _vm._v(" "), _c('comboboxV2', {
    attrs: {
      "label": "Pályázott ösztöndíj",
      "name": "osztondij_id",
      "errors": _vm.errors,
      "id": "osztondij_id",
      "options": _vm.palyazhato_osztondijak
    },
    on: {
      "onChange": _vm.osztondijValtoztat
    },
    model: {
      value: (_vm.form.values.osztondij_id),
      callback: function($$v) {
        _vm.form.values.osztondij_id = $$v
      },
      expression: "form.values.osztondij_id"
    }
  })], 1), _vm._v(" "), (_vm.form.values.osztondij_id != '') ? [_vm._m(0), _vm._v(" "), (_vm.hallgato_alapadatok_t.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Szakok",
      "id": "szak_id",
      "name": "szak_id",
      "options": _vm.szak_combo_opts
    },
    on: {
      "onChange": function (index) {
        _vm.szakValt(index);
      }
    },
    model: {
      value: (_vm.szak_combo_index),
      callback: function($$v) {
        _vm.szak_combo_index = $$v
      },
      expression: "szak_combo_index"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": _vm.hallgato_alapadatok_t.length > 0,
      "label": "Név",
      "errors": _vm.errors,
      "id": "nev",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.nev),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.nev = $$v
      },
      expression: "form.hallgato_alapadatok.nev"
    }
  }), _vm._v(" "), _c('inputbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.neptunkodLatszik()),
      expression: "neptunkodLatszik()"
    }],
    attrs: {
      "label": "Neptunkód",
      "errors": _vm.errors,
      "regexp_filter": "[a-zA-Z0-9]+",
      "id": "neptunkod",
      "name": "neptunkod"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.neptunkod),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.neptunkod = $$v
      },
      expression: "form.hallgato_alapadatok.neptunkod"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "label": "Email cím",
      "errors": _vm.errors,
      "id": "email",
      "name": "email",
      "regexp_filter": "[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.email),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.email = $$v
      },
      expression: "form.hallgato_alapadatok.email"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "label": "Mobilszám",
      "errors": _vm.errors,
      "id": "mobilszam",
      "name": "mobilszam",
      "regexp_filter": "[+0-9 /-]+"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.mobilszam),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.mobilszam = $$v
      },
      expression: "form.hallgato_alapadatok.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": _vm.hallgato_alapadatok_t.length > 0,
      "label": "Születési hely, idő",
      "errors": _vm.errors,
      "id": "szulhelyido",
      "name": "szulhelyido"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.szulhelyido),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.szulhelyido = $$v
      },
      expression: "form.hallgato_alapadatok.szulhelyido"
    }
  }), _vm._v(" "), _c('inputbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (0),
      expression: "0"
    }],
    attrs: {
      "disabled": _vm.hallgato_alapadatok_t.length > 0,
      "label": "Képzés szintje",
      "errors": _vm.errors,
      "id": "kepzes_szint",
      "name": "kepzes_szint"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.kepzes_szint),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.kepzes_szint = $$v
      },
      expression: "form.hallgato_alapadatok.kepzes_szint"
    }
  }), _vm._v(" "), _c('inputbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.szakLatszik()),
      expression: "szakLatszik()"
    }],
    attrs: {
      "disabled": _vm.hallgato_alapadatok_t.length > 0,
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\\-\\,]+",
      "label": "Szak",
      "errors": _vm.errors,
      "id": "szak",
      "name": "szak"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.szak),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.szak = $$v
      },
      expression: "form.hallgato_alapadatok.szak"
    }
  }), _vm._v(" "), _c('inputbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.karLatszik()),
      expression: "karLatszik()"
    }],
    attrs: {
      "disabled": _vm.hallgato_alapadatok_t.length > 0,
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\\-\\,]+",
      "label": "Kar",
      "errors": _vm.errors,
      "id": "kar",
      "name": "kar"
    },
    model: {
      value: (_vm.form.hallgato_alapadatok.kar),
      callback: function($$v) {
        _vm.form.hallgato_alapadatok.kar = $$v
      },
      expression: "form.hallgato_alapadatok.kar"
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Pályázott ösztöndíjas jogviszony időtartama",
      "name": "jogviszony_idotartam",
      "id": "jogviszony_idotartam",
      "options": _vm.jogviszonyidotartamok
    },
    model: {
      value: (_vm.form.values.jogviszony_idotartam),
      callback: function($$v) {
        _vm.form.values.jogviszony_idotartam = $$v
      },
      expression: "form.values.jogviszony_idotartam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "2022/2023. tanévi ÚNKP Ösztöndíjban részesültem",
      "name": "unkp_reszesult_e",
      "id": "unkp_reszesult_e",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.unkp_reszesult_e),
      callback: function($$v) {
        _vm.form.values.unkp_reszesult_e = $$v
      },
      expression: "form.values.unkp_reszesult_e"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "tooltipDescription": "Doktori hallgatók esetén az ösztöndíj keretében végzett kutatás a doktori tanulmányok által megkövetelt kutatómunkához kapcsolódhat, de azon felüli extra kutatási tevékenységnek kell lennie.",
      "label": "Kutatási/művészeti téma címe",
      "errors": _vm.errors,
      "id": "tema_cim",
      "name": "tema_cim"
    },
    model: {
      value: (_vm.form.values.tema_cim),
      callback: function($$v) {
        _vm.form.values.tema_cim = $$v
      },
      expression: "form.values.tema_cim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Kutatási/művészeti téma tudományterületi besorolása",
      "id": "tudomanyterulet",
      "name": "tudomanyterulet",
      "options": _vm.tudomanyteruletek
    },
    on: {
      "onChange": function($event) {
        _vm.tudomanyAgak(true)
      }
    },
    model: {
      value: (_vm.form.values.tudomanyterulet),
      callback: function($$v) {
        _vm.form.values.tudomanyterulet = $$v
      },
      expression: "form.values.tudomanyterulet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Kutatási/művészeti téma tudományági besorolása",
      "id": "tudomanyag",
      "name": "tudomanyag",
      "options": _vm.tudomanyagak
    },
    model: {
      value: (_vm.form.values.tudomanyag),
      callback: function($$v) {
        _vm.form.values.tudomanyag = $$v
      },
      expression: "form.values.tudomanyag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": _vm.temavezetoNevKitoltes(),
      "label": "Témavezető neve",
      "errors": _vm.errors,
      "id": "temavezeto_neve",
      "name": "temavezeto_neve",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_neve),
      callback: function($$v) {
        _vm.form.values.temavezeto_neve = $$v
      },
      expression: "form.values.temavezeto_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": _vm.temavezetoEmailKitoltes(),
      "label": "Témavezető e-mail címe",
      "errors": _vm.errors,
      "id": "temavezeto_email",
      "name": "temavezeto_email",
      "regexp_filter": "[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}"
    },
    model: {
      value: (_vm.form.values.temavezeto_email),
      callback: function($$v) {
        _vm.form.values.temavezeto_email = $$v
      },
      expression: "form.values.temavezeto_email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": _vm.temavezetoTelefonKitoltes(),
      "label": "Témavezető mobilszáma",
      "errors": _vm.errors,
      "id": "temavezeto_mobil",
      "name": "temavezeto_mobil",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_mobil),
      callback: function($$v) {
        _vm.form.values.temavezeto_mobil = $$v
      },
      expression: "form.values.temavezeto_mobil"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.makoveczLatszik()),
      expression: "makoveczLatszik()"
    }]
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "tooltipDescription": "A 2021/2022., 2022/2023. tanévben Makovecz Hallgatói Ösztöndíjprogram keretében határon túli felsőoktatási intézményben legalább 5 hónap időtartamban teljes szemeszteres részképzésen vagy részképzős tanulmányúton történő részvétel (megkezdett vagy lezárt).",
      "label": "Makovecz Hallgatói Ösztöndíjprogram részvétel",
      "name": "makovecz_hallgatoi_osztondijprogram_reszvetel",
      "id": "makovecz_hallgatoi_osztondijprogram_reszvetel",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.makovecz_hallgatoi_osztondijprogram_reszvetel),
      callback: function($$v) {
        _vm.form.values.makovecz_hallgatoi_osztondijprogram_reszvetel = $$v
      },
      expression: "form.values.makovecz_hallgatoi_osztondijprogram_reszvetel"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.makovecz_hallgatoi_osztondijprogram_reszvetel == 'igen'),
      expression: "form.values.makovecz_hallgatoi_osztondijprogram_reszvetel == 'igen'"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "makovecz_igazolas",
      "label": "Igazolás",
      "name": "makovecz_igazolas",
      "loaded_files": _vm.form.values.makovecz_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'makovecz_igazolas');
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.proScientiaLatszik()),
      expression: "proScientiaLatszik()"
    }]
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Pro Scientia/Arte Aranyérmet nyert",
      "name": "pro_scientia_arte_reszvetel",
      "id": "pro_scientia_arte_reszvetel",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.pro_scientia_arte_reszvetel),
      callback: function($$v) {
        _vm.form.values.pro_scientia_arte_reszvetel = $$v
      },
      expression: "form.values.pro_scientia_arte_reszvetel"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.pro_scientia_arte_reszvetel == 'igen'),
      expression: "form.values.pro_scientia_arte_reszvetel == 'igen'"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "pro_scientia_arte_igazolas",
      "label": "Igazolás",
      "name": "pro_scientia_arte_igazolas",
      "loaded_files": _vm.form.values.pro_scientia_arte_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'pro_scientia_arte_igazolas');
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.otdkLatszik()),
      expression: "otdkLatszik()"
    }]
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "OTDK-n ért-e el I., II. vagy III. helyezést",
      "name": "otdk_reszvetel",
      "id": "otdk_reszvetel",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.otdk_reszvetel),
      callback: function($$v) {
        _vm.form.values.otdk_reszvetel = $$v
      },
      expression: "form.values.otdk_reszvetel"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.otdk_reszvetel == 'igen'),
      expression: "form.values.otdk_reszvetel == 'igen'"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "otdk_reszvetel_igazolas",
      "label": "Igazolás",
      "name": "otdk_reszvetel_igazolas",
      "loaded_files": _vm.form.values.otdk_reszvetel_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'otdk_reszvetel_igazolas');
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ABTudomanyosPublikacioSzerzojeLatszik()),
      expression: "ABTudomanyosPublikacioSzerzojeLatszik()"
    }]
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "tooltipDescription": "’Igen’ válasz esetén kérjük a publikáció(ka)t feltölteni a „Pályázat benyújtásáig megvalósult tudományos/művészeti tevékenységét bemutató, elismerő dokumentáció” pontban.",
      "label": "Scimago Journal Ranking szerinti Q1/Q2 és/vagy a Magyar Tudományos Akadémia tudományos osztályai által “A” vagy “B” kategóriába sorolt folyóiratokban megjelent tudományos publikáció szerzője",
      "name": "a_b_tudomanyos_publikacio_szerzoje",
      "id": "a_b_tudomanyos_publikacio_szerzoje",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.a_b_tudomanyos_publikacio_szerzoje),
      callback: function($$v) {
        _vm.form.values.a_b_tudomanyos_publikacio_szerzoje = $$v
      },
      expression: "form.values.a_b_tudomanyos_publikacio_szerzoje"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kutatocsoportEgyuttmukodesLatszik()),
      expression: "kutatocsoportEgyuttmukodesLatszik()"
    }]
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "tooltipDescription": "A kutatási terv kutatócsoport keretében kerül megvalósításra VAGY a pályázó a Magyar Tudományos Akadémiával vagy a fogadó felsőoktatási intézményen kívüli felsőoktatási intézménnyel kutatócsoport keretében együttműködik a kutatási terve megvalósítása során.",
      "label": "Kutatócsoporttal együttműködés",
      "name": "kutatocsoport_egyuttmukodes",
      "id": "kutatocsoport_egyuttmukodes",
      "options": _vm.igen_nem
    },
    model: {
      value: (_vm.form.values.kutatocsoport_egyuttmukodes),
      callback: function($$v) {
        _vm.form.values.kutatocsoport_egyuttmukodes = $$v
      },
      expression: "form.values.kutatocsoport_egyuttmukodes"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.kutatocsoport_egyuttmukodes == 'igen'),
      expression: "form.values.kutatocsoport_egyuttmukodes == 'igen'"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "kutatocsoport_egyuttmukodes_igazolas",
      "label": "Igazolás",
      "name": "kutatocsoport_egyuttmukodes_igazolas",
      "loaded_files": _vm.form.values.kutatocsoport_egyuttmukodes_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'kutatocsoport_egyuttmukodes_igazolas');
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "palyazati_adatlap",
      "label": "Kitöltött, aláírt pályázati adatlap",
      "name": "palyazati_adatlap",
      "loaded_files": _vm.form.values.palyazati_adatlap
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazati_adatlap');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "errors": _vm.errors,
      "id": "palyazati_adatlap_szerkesztheto",
      "label": "Kitöltött pályázati adatlap szerkeszthető (Excel fájl)",
      "name": "palyazati_adatlap_szerkesztheto",
      "loaded_files": _vm.form.values.palyazati_adatlap_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazati_adatlap_szerkesztheto');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "alairt_kutatasi_terv",
      "label": _vm.form.values.osztondij_id == '23_5' || _vm.form.values.osztondij_id == '23_4_2' ? 'Aláírt kutatási terv (pályázó által aláírva)' : 'Aláírt kutatási terv (témavezető és pályázó által aláírva)',
      "name": "alairt_kutatasi_terv",
      "loaded_files": _vm.form.values.alairt_kutatasi_terv
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'alairt_kutatasi_terv');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "alairt_palyazoi_nyilatkozat",
      "label": "Aláírt pályázói nyilatkozat",
      "name": "alairt_palyazoi_nyilatkozat",
      "loaded_files": _vm.form.values.alairt_palyazoi_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'alairt_palyazoi_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "tooltipDescription": "Rektori aláírásra a témavezető és a kari dékán által <strong>MÁR ALÁÍRT</strong> nyilatkozatot lehet leadni az Igazgatási Épület 2. emeletén a 203-as irodában mellékelve egy <strong>e-mail címet</strong>, melyre az aláírt nyilatkozatot visszaküldhetjük. Kérjük a leadásnál figyelembe venni, hogy a rektori aláírás átfutása akár több munkanap is lehet.",
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "alairt_intezmenyi_fogado_nyilatkozat",
      "label": "Aláírt intézményi fogadó nyilatkozat (témavezető, kari dékán, intézmény rektora által aláírva)",
      "name": "alairt_intezmenyi_fogado_nyilatkozat",
      "loaded_files": _vm.form.values.alairt_intezmenyi_fogado_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'alairt_intezmenyi_fogado_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tehetseggelFelIgazolasLatszik()),
      expression: "tehetseggelFelIgazolasLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "tehetseggel_fel_igazolas",
      "label": "Igazolás a Pályázati Kiírás 4.1.4. pontjában felsorolt eredményről (versenyeredmények)",
      "name": "tehetseggel_fel_igazolas",
      "loaded_files": _vm.form.values.tehetseggel_fel_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tehetseggel_fel_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tanulmanyiEredmenyIgazolasLatszik()),
      expression: "tanulmanyiEredmenyIgazolasLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "tanulmanyi_eredmeny_igazolas",
      "label": "A tanulmányi eredményről szóló igazolás hiánytalanul, magyar nyelven kitöltve, Tanulmányi Osztály által hitelesítve",
      "name": "tanulmanyi_eredmeny_igazolas",
      "loaded_files": _vm.form.values.tanulmanyi_eredmeny_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tanulmanyi_eredmeny_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tudomanyosMuveszetiTevekenysegetBemutatoDokumentacioLatszik()),
      expression: "tudomanyosMuveszetiTevekenysegetBemutatoDokumentacioLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "30",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio",
      "label": _vm.tudomanyosMuveszetiTevekenysegetBemutatoDokumentacioCim(),
      "name": "tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio",
      "loaded_files": _vm.form.values.tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tudomanyos_muveszeti_tevekenyseget_bemutato_dokumentacio');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hallgatoiMunkaltatoiJogviszonyigazolasTanulmanyiOsztalyDoktoriIskolaHumaneroforrasOsztalyAltalHitelesitveLatszik()),
      expression: "hallgatoiMunkaltatoiJogviszonyigazolasTanulmanyiOsztalyDoktoriIskolaHumaneroforrasOsztalyAltalHitelesitveLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "tooltipDescription": _vm.form.values.osztondij_id == '23_5' || _vm.form.values.osztondij_id == '23_4_1' || _vm.form.values.osztondij_id == '23_4_2' || _vm.form.values.osztondij_id == '23_3_2' ? false : 'Amennyiben nem rendelkezik ezen dokumentumok egyikével sem, akkor vagy felvételi jelentkezéről / felvételi döntésről szóló dokumentumot legyen kedves csatolni / munkaviszony esetében pedig a terveiről egy rövid beszámolót, melyik szervezeti egység munkájába kapcsolódna be.',
      "max_uploaded_files": "5",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve",
      "label": _vm.hallgatoiMunkaltatoiJogviszonyigazolasTanulmanyiOsztalyDoktoriIskolaHumaneroforrasOsztalyAltalHitelesitveCim(),
      "name": "hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve",
      "loaded_files": _vm.form.values.hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'hallgatoi_munkaltatoi_jogviszonyigazolas_tanulmanyi_osztaly_doktori_iskola_humaneroforras_osztaly_altal_hitelesitve');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.felviHuJelentkezesiAdatlapLatszik()),
      expression: "felviHuJelentkezesiAdatlapLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "felvi_hu_jelentkezesi_adatlap",
      "label": "Felvi.hu felületéről generálható felvételi jelentkezési adatlap",
      "name": "felvi_hu_jelentkezesi_adatlap",
      "loaded_files": _vm.form.values.felvi_hu_jelentkezesi_adatlap
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'felvi_hu_jelentkezesi_adatlap');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik()),
      expression: "nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve",
      "label": "Nyilatkozat felvételi jelentkezésről illetékes Doktori Iskola ügyintézője által hitelesítve (A nyilatkozatot a pályázó készíti el, arra vonatkozóan, hogy melyik doktori iskolába adták be felvételi jelentkezésüket.)",
      "name": "nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve",
      "loaded_files": _vm.form.values.nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bizonyitvanyMasolatLatszik()),
      expression: "bizonyitvanyMasolatLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "bizonyitvany_masolat",
      "label": "Bizonyítvány másolat (Középfokú képzésben teljesített tanulmányi eredményének utolsó 2 lezárt félévi átlaga lezárt félévenként legalább 4,00 minősítésű legyen.)",
      "name": "bizonyitvany_masolat",
      "loaded_files": _vm.form.values.bizonyitvany_masolat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'bizonyitvany_masolat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bolyaiKutatasiOsztondijElnyereseIgazolasLatszik()),
      expression: "bolyaiKutatasiOsztondijElnyereseIgazolasLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "bolyai_kutatasi_osztondij_elnyerese_igazolas",
      "label": "Az MTA Bolyai János Kutatási Ösztöndíj elnyeréséről szóló értesítés",
      "name": "bolyai_kutatasi_osztondij_elnyerese_igazolas",
      "loaded_files": _vm.form.values.bolyai_kutatasi_osztondij_elnyerese_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'bolyai_kutatasi_osztondij_elnyerese_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abszolutoriumMegszerzesetIgazoloDokumentumElektronikusanLatszik()),
      expression: "abszolutoriumMegszerzesetIgazoloDokumentumElektronikusanLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan",
      "label": "Az abszolutórium megszerzését igazoló dokumentum elektronikusan (Amennyiben a pályázó az abszolutóriumot nem szerezte meg, a pályázó által aláírt nyilatkozat arról, hogy az ösztöndíjszerződés megkötéséig az abszolutóriumot várhatóan megszerzi)",
      "name": "abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan",
      "loaded_files": _vm.form.values.abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'abszolutorium_megszerzeset_igazolo_dokumentum_elektronikusan');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phdDlaFokozatMegszerzesetIgazoloDokumentumLatszik()),
      expression: "phdDlaFokozatMegszerzesetIgazoloDokumentumLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "phd_dla_fokozat_megszerzeset_igazolo_dokumentum",
      "label": "A PhD/DLA fokozat megszerzését igazoló dokumentum (amennyiben a pályázat benyújtásakor a fokozatot megszerezte)",
      "name": "phd_dla_fokozat_megszerzeset_igazolo_dokumentum",
      "loaded_files": _vm.form.values.phd_dla_fokozat_megszerzeset_igazolo_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'phd_dla_fokozat_megszerzeset_igazolo_dokumentum');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doktoriKepzesReszetKepezoFelkeszulesbenValoReszveteltIgazoloDokumentumLatszik()),
      expression: "doktoriKepzesReszetKepezoFelkeszulesbenValoReszveteltIgazoloDokumentumLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum",
      "label": "Doktori képzés részét képező felkészülésben való részvételt igazoló dokumentum",
      "name": "doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum",
      "loaded_files": _vm.form.values.doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'doktori_kepzes_reszet_kepezo_felkeszulesben_valo_reszvetelt_igazolo_dokumentum');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tanulmanyiEredmenyIgazolasElsoFelevLatszik()),
      expression: "tanulmanyiEredmenyIgazolasElsoFelevLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "tanulmanyi_eredmeny_elso_felev_igazolas",
      "label": "Igazolás az első félév tanulmányi eredményéről",
      "name": "tanulmanyi_eredmeny_elso_felev_igazolas",
      "loaded_files": _vm.form.values.tanulmanyi_eredmeny_elso_felev_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tanulmanyi_eredmeny_elso_felev_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nyelvtudastIgazoloDokumentumLatszik()),
      expression: "nyelvtudastIgazoloDokumentumLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Opcionális mellékletek\n          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nyelvtudastIgazoloDokumentumLatszik()),
      expression: "nyelvtudastIgazoloDokumentumLatszik()"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "5",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "nyelvtudast_igazolo_dokumentum",
      "label": "Nyelvtudást igazoló dokumentum",
      "name": "nyelvtudast_igazolo_dokumentum",
      "loaded_files": _vm.form.values.nyelvtudast_igazolo_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'nyelvtudast_igazolo_dokumentum');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nyilatkozat_elfogadasa),
      expression: "nyilatkozat_elfogadasa"
    }],
    attrs: {
      "id": "nyilatkozat_elfogadasa",
      "name": "nyilatkozat_elfogadasa",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.nyilatkozat_elfogadasa) ? _vm._i(_vm.nyilatkozat_elfogadasa, "1") > -1 : (_vm.nyilatkozat_elfogadasa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.nyilatkozat_elfogadasa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.nyilatkozat_elfogadasa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.nyilatkozat_elfogadasa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.nyilatkozat_elfogadasa = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozat_elfogadasa') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '' && _vm.kitoltes_valaszto == false) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }), _vm._v(" "), (_vm.remedy) ? _c('div', [_c('div', {
    staticClass: "info-box warning",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n            Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "javascript:void(0)",
      "title": ""
    },
    on: {
      "click": function($event) {
        _vm.remedy_popup = true;
      }
    }
  }, [_vm._v("Fellebezés")])]) : _vm._e(), _vm._v(" "), (_vm.remedy_user != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_user.name))]), _vm._v(" (" + _vm._s(_vm.remedy_user.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_user.msg))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.remedy_admin != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés válasz")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_admin.name))]), _vm._v(" (" + _vm._s(_vm.remedy_admin.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_admin.msg))
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.remedy && _vm.$route.query.id != undefined && _vm.remedy_popup) ? _c('Fellebezes', {
    attrs: {
      "form_id": _vm.$route.query.id
    },
    on: {
      "close": function (final) {
        _vm.remedy_popup = false;
        if (final) { _vm.remedy = false; }
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Alapadatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Pályázat alapadatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n              Makovecz Hallgatói Ösztöndíjprogram\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n              Pro Scientia/Arte Aranyérem\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n              OTDK\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n              Scimago Journal Ranking szerinti Q1/Q2 és/vagy a Magyar Tudományos Akadémia tudományos osztályai által “A” vagy “B” kategóriába sorolt folyóiratokban megjelent tudományos publikáció szerzője\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n              Kutatócsoport együttműködés\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Kötelezően feltöltendő dokumentumok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozat_elfogadasa"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', [_vm._v("\n                  Jelen pályázati anyagom benyújtásával egyidejűleg kijelentem, hogy nyertes pályázatom esetén az Új Nemzeti Kiválóság Program 2023/2024 ösztöndíjas jogviszony létesítésekor igazolom az ösztöndíjszerződés létesítéséhez, valamint az ösztöndíjas jogviszony fenntartásához szükséges "), _c('strong', [_c('u', [_vm._v("AKTÍV")]), _vm._v(" hallgatói jogviszonyomat/ munkaviszonyomat vagy munkavégzésre irányuló egyéb jogviszonyomat")]), _vm._v(", és vállalom, hogy ezt az ösztöndíjas jogviszony teljes időtartama alatt mindvégig fenntartom.\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab16f32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/unkp2023.vue
// module id = 345
// module chunks = 0